import React from "react";
import selfDevelopmentIcon from "../../images/talent-self-development.svg";
import challengeIcon from "../../images/talent-challenge.svg";
import creativityIcon from "../../images/talent-creativity.svg";
import globalIcon from "../../images/talent-global.svg";

const RecruitmentInfo = () => {
  const isMobile = window.innerWidth < 576;
  const isTablet = window.innerWidth >= 576 && window.innerWidth < 1200;
  const isDesktop = window.innerWidth >= 1200;

  const circleMaxWidth = isMobile ? "200px" : "280px";
  const titleSize = isMobile ? "18px" : "28px";
  const subTitleSize = isMobile ? "11px" : "14px";
  const descSize = isMobile ? "16px" : "18px";
  const iconSize = isMobile ? 40 : 50;
  const lineHeight = isMobile ? "40px" : "50px";

  const cardData = [
    {
      title: "자기개발",
      subTitle: "Self-development",
      outerBg: "rgba(0, 78, 162, 0.2)",
      innerBg: "#27486B",
      desc: "맡은 분야의 업무 지식과\n핵심 역량을 갖추고\n최고를 지향하는 사람",
      icon: selfDevelopmentIcon,
    },
    {
      title: "도전정신",
      subTitle: "Spirit of challenge",
      outerBg: "rgba(79, 88, 108, 0.2)",
      innerBg: "#4F586C",
      desc: "실패를 두려워 하지 않고\n스스로 극복해\n내는 사람",
      icon: challengeIcon,
    },
    {
      title: "창의력",
      subTitle: "Creativity",
      outerBg: "rgba(4, 144, 137, 0.2)",
      innerBg: "#049089",
      desc: "유연한 사고를 숙고 하여\n근본부터 뒤집어\n볼 수 있는 사람",
      icon: creativityIcon,
    },
    {
      title: "글로벌",
      subTitle: "Global",
      outerBg: "rgba(0, 78, 162, 0.2)",
      innerBg: "rgba(0, 78, 162, 0.7)",
      desc: "글로벌 업무 경쟁력을\n바탕으로 글로벌 시장을\n개척해 내는 사람",
      icon: globalIcon,
    },
  ];

  return (
    <div
      className="pricing-page section-padding"
      style={{ paddingBottom: "0px" }}
    >
      <div className="container">
        <div style={{ marginBottom: isMobile ? "40px" : "60px" }}>
          <h2
            style={{
              fontSize: isMobile ? "28px" : "40px",
              fontWeight: "700",
              marginBottom: "20px",
              color: "#000",
              lineHeight: "140%",
            }}
          >
            나를 개혁하고 미래에 도전하며 {!isDesktop && <br />}
            새로운 가치를 만들어 내는 {isDesktop && <br />}
            엠알메탈로
          </h2>
          <p
            style={{
              fontSize: isMobile ? "16px" : "18px",
              color: "#333",
              lineHeight: "1.8",
              marginTop: "30px",
            }}
          >
            ㈜엠알메탈로는 폐수, 폐기물에서 자원화를 실현하는
            종합환경전문기업으로써 끊임없는
            {!isMobile && <br />} 변화와 도전정신을 갖춘 미래를 함께할 역량 있는
            인재를 모십니다.
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: isMobile ? "30px" : "20px",
          }}
        >
          {cardData.map((card, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
                marginBottom: "30px",
                width: isMobile ? "45%" : isTablet ? "45%" : "23%",
                minWidth: isMobile ? "140px" : "200px",
              }}
            >
              {/* 원형 배지 */}
              <div
                style={{
                  width: "100%",
                  maxWidth: circleMaxWidth,
                  aspectRatio: "1",
                  borderRadius: "50%",
                  background: card.outerBg,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: isMobile ? "12px" : "0px",
                }}
              >
                <div
                  style={{
                    width: "85%",
                    aspectRatio: "1",
                    borderRadius: "50%",
                    background: card.innerBg,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: isMobile ? "8px" : "12px",
                  }}
                >
                  {/* 아이콘 */}
                  <img
                    src={card.icon}
                    alt={card.title}
                    width={iconSize}
                    height={iconSize}
                  />
                  <div style={{ textAlign: "center" }}>
                    <h3
                      style={{
                        fontSize: titleSize,
                        fontWeight: "700",
                        color: "#fff",
                        margin: "0 0 4px 0",
                      }}
                    >
                      {card.title}
                    </h3>
                    <p
                      style={{
                        fontSize: subTitleSize,
                        fontWeight: "700",
                        color: "#fff",
                        margin: "0",
                      }}
                    >
                      {card.subTitle}
                    </p>
                  </div>
                </div>
              </div>
              {/* 점선 구분선 */}
              <div
                style={{
                  width: "2px",
                  height: lineHeight,
                  borderLeft: "2px dashed #DACCCC",
                }}
              ></div>
              {/* 설명 텍스트 */}
              <p
                style={{
                  fontSize: descSize,
                  color: "#383643",
                  textAlign: "center",
                  lineHeight: "1.8",
                  margin: "0",
                  whiteSpace: "pre-line",
                }}
              >
                {card.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecruitmentInfo;
